import { CategoryType, PaginationType, UserLoginType } from "@/DTO";
import { Api } from "@/api";
import { convertCategory } from "./single";
import { ConvertToPaginationType } from "@/api/help";

export const getCategoryList = (
  user: UserLoginType,
  pagination: PaginationType,
  name: string = ""
) => {
  return new Promise<{
    data: CategoryType[];
    pagination: PaginationType
  }>(
    (resolve, reject) => {
      const api = new Api({
        method: "get",
        path: "category",
        header: {
          Authorization: "Bearer " + user?.accessToken
        },
        params: {
          page: pagination.currentPage,
          per_page: pagination.perPage,
          name: name
        }
      });
      return api
        .call()
        .then((data: any) => {
          return resolve({
            data: convertToCategoryList(data.data),
            pagination: ConvertToPaginationType(data)
          });
        })
        .catch((err: any) => {
          return reject(err);
        });
    }
  );
};

export function convertToCategoryList(data: any[]): CategoryType[] {
  const userList = data.map((item: any) => {
    return convertCategory(item);
  });
  return userList;
}
